export class Product {
  constructor(
    public indskr_productid: string,
    public indskr_productname: string,
    public isChecked?: boolean,
    public indskr_consentId?: string
  ) {}
}
